import { Transaction } from '../types';
import { sellerDetailView, buyerDetailView } from '../../utils/navigation';

export const createTransactionLink = (transaction: Transaction) => {
    const { role, adIds, transactionId } = transaction;
    if (role === 'SELLER' && adIds) {
        return sellerDetailView(adIds[0]); // temporarily, until we can handle a link for bundles as well
    }

    if (role === 'BUYER' && transactionId) {
        return buyerDetailView(transactionId.toString());
    }

    console.error(`User with role ${role} is missing transaction/ad ID`);
    return '';
};
